import { SVGInjector } from "@tanem/svg-injector";

export function injectSvgs(svgMarkerClass: string) {
  SVGInjector(document.getElementsByClassName(svgMarkerClass), {
    afterAll(elementsLoaded) {
      //console.log(`injected ${elementsLoaded} elements`);
    },
    afterEach(err, svg) {
      if (err) {
        throw err;
      }

      //console.log(`injected ${svg.outerHTML}`);
    },
    beforeEach(svg) {
      var pc = document.getElementById("product-configurator");
      var basePath = pc.getAttribute("data-svg-base-href");

      svg.querySelectorAll("#Licht_Einzeln_klein_neu image").forEach((f) => {
        var tmp = f.getAttribute("xlink:href");
        f.setAttribute("xlink:href", basePath + "/src/assets/glassroof/" + tmp);
      });
    },
    cacheRequests: false,
    evalScripts: "never",
    httpRequestWithCredentials: false,
    renumerateIRIElements: false,
  });
}
